import { StandardMaterial, BLEND_NORMAL, Color } from "playcanvas";
import { MaterialOverride } from "../utility/material-override-manager";
import { isSpecialModelParserNode } from "src/scene/colliders/utility";

export const materialOverrides = {
	collision: {
		layer: 0,
		material: createGhostMaterial(Color.RED, 0.2),
		ignoredNodeFilter: isSpecialModelParserNode,
	},
	invalidPlacement: {
		layer: 1,
		material: createGhostMaterial(Color.WHITE, 0.1),
		ignoredNodeFilter: isSpecialModelParserNode,
	},
} satisfies Record<string, MaterialOverride>;

function createGhostMaterial(
	color: Color,
	opacity: number,
	blendType = BLEND_NORMAL,
) {
	const material = new StandardMaterial();
	material.diffuse.copy(color);
	material.opacity = opacity;
	material.blendType = blendType;
	return material;
}
